﻿export const getDisplayValue = ({
  displayName,
  givenName,
  surname,
  email,
  name,
} = {}) =>
  displayName ||
  (givenName && surname && `${surname}, ${givenName}`) ||
  email ||
  name;
